import { render } from "./GallerySwitch.vue?vue&type=template&id=e4269a86&ts=true"
import script from "./GallerySwitch.vue?vue&type=script&lang=ts"
export * from "./GallerySwitch.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__